<template>
  <LayoutAdmin :active-periode="activePeriodic">
    <section class="w-full px-8 mt-6 overflow-x-hiden">
      <section class="flex justify-between mb-5">
        <section class="flex items-center">
          <h1 class="text-2xl">Payrun Type</h1>
          <ChoiseCompany v-if="!isLoading && optionsCompany.length"
            @selected:company="changeCompany($event)" :options="optionsCompany" :dataCompany="dataCompany" />
        </section>
        <Button class="px-6 py-2 mx-2 text-white rounded bg-primary" @click="openFormPayrunType">Add Payrun Type</Button>
      </section>
      <Loading v-if="isLoading" />
      <TablePayrunType v-else :payrun-types="payrunTypes" :is-loading="isLoading" @on-edit="editPayrunType"
        @on-delete="deletePayrunType" @on-set-default="onSetDefault" />
    </section>
  </LayoutAdmin>
  <ModalPayrunType v-if="modalShow" :title="'Payrun Type'" :payrun-type="payrunType" :companies="optionsCompany"
    :company="dataCompany" :colors="colors" :output-files="outputFiles" @on-submit-payrun-type="submitPayrunType"
    @on-update-payrun-type="updateDataPayrunType" @close="modalShow = false" />
  <ModalDelete v-if="showModalDelete" :title="'Delete'" :payrun-type="payrunType.payrun_type"
    @close="showModalDelete = false" @on-delete-payrun-type="onDeletePayrunType" />
</template>

<script>
import LayoutAdmin from "@/components/Layout/Admin.vue";
import { GetAllCompanyEmployeeOptionsAPI } from "@/actions/company";
import { GetDepartementAPI } from "@/actions/departement";
import {
  getPayrunTypes,
  addPayrunType,
  updatePayrunType,
  deletePayrunType,
  updateDefaultPayrunType,
} from "@/actions/payruntype";
import { getOutputFile } from "@/actions/output-file";
import { GetPeriodicActiveAPI } from "@/actions/periodic";
import ChoiseCompany from "@/components/ChoiseCompany.vue";
import TablePayrunType from "@/components/PayrunType/TablePayrunType.vue";
import Button from "@/components/Button.vue";
import Loading from "@/components/Loading.vue";
import ModalPayrunType from "@/components/PayrunType/ModalPayrunType.vue";
import ModalDelete from "@/components/PayrunType/ModalDelete.vue";
import decryptToken from "@/utils/decryptToken";
import { useToast } from "vue-toastification";

export default {
  name: "PayrunType",
  components: {
    LayoutAdmin,
    ChoiseCompany,
    TablePayrunType,
    Button,
    ModalPayrunType,
    Loading,
    ModalDelete,
  },
  setup() {
    const toast = useToast();
    return { getPayrunTypes, toast };
  },
  data() {
    return {
      activePeriodic: "-",
      superAdmin: false,
      dataCompany: {},
      optionsCompany: [],
      payrunTypes: [],
      payrunType: {},
      isLoading: true,
      modalShow: false,
      showModalDelete: false,
      colors: [
        { value: "gray", text: "Gray" },
        { value: "orange", text: "Orange" },
        { value: "green", text: "Green" },
      ],
      outputFiles: [],
      selectedFile: null,
    };
  },
  mounted() {
    const payload = decryptToken();
    this.superAdmin =
      payload?.role === "Super Admin" || payload?.role === "Group Admin";
    this.getAllCompany();
    this.getOutputFile();
  },
  methods: {
    async getPayrunType() {
      const companyId = this.dataCompany?._id;
      const { data, success, code, message } = await getPayrunTypes(companyId);

      if (success) {
        this.payrunTypes = data;
        this.isLoading = false;
      } else {
        this.isLoading = false;
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    async getOutputFile() {
      const { data, success, code, message } = await getOutputFile();

      if (success) {
        this.outputFiles = data;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    async getAllCompany() {
      this.isLoading = true;

      const response = await GetAllCompanyEmployeeOptionsAPI();
      this.optionsCompany = response.data;
      this.dataCompany = response.data[0];
      this.getPayrunType();
    },
    async handleGetDepartement() {
      const querySuperAdmin = `?company=${this.dataCompany?._id}`;
      const response = await GetDepartementAPI(querySuperAdmin);
      if (response.status === 401) {
        return this.$router.push("/login");
      }
      this.departement = response.data;
    },

    changeCompany(e) {
      this.dataCompany = e;

      this.getPayrunType();
    },
    openFormPayrunType() {
      this.modalShow = true;
      this.payrunType = {};
    },
    editPayrunType(value) {
      this.payrunType = value;
      this.modalShow = true;
    },
    async submitPayrunType(value) {
      this.isLoading = true;
      const { success, code, message, data } = await addPayrunType(value);
      if (success) {
        this.toast.success("Created payrun type");
        this.getPayrunType();
        this.modalShow = false;
        this.isLoading = false;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else if (code === 400) {
          this.showErrorValidation(data);
        } else {
          this.toast.error(message);
        }
      }
    },
    async updateDataPayrunType(value) {
      this.isLoading = true;
      const { success, code, message, data } = await updatePayrunType(value);
      if (success) {
        this.toast.success("Updated payrun type");
        this.getPayrunType();
        this.modalShow = false;
        this.isLoading = false;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else if (code === 400) {
          this.showErrorValidation(data);
        } else {
          this.toast.error(message);
        }
      }
    },
    deletePayrunType(value) {
      this.payrunType = value;
      this.showModalDelete = true;
    },
    async onDeletePayrunType() {
      this.isLoading = true;
      const { success, code, message } = await deletePayrunType(
        this.payrunType._id
      );
      if (success) {
        this.toast.success("Deleted payrun type");
        this.getPayrunType();
        this.showModalDelete = false;
        this.isLoading = false;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    showErrorValidation(value) {
      this.toast.error(value.company_id);
      this.toast.error(value.color);
      this.toast.error(value.output_file);
      this.toast.error(value.payrun_type);
    },
    async onSetDefault({ id, isDefault }) {
      const { success, message, code } = await updateDefaultPayrunType({
        id,
        isDefault,
      });
      if (success) {
        this.toast.success("Update default successfull");
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    async handleGetPeriodicActive() {
      const querySuperAdmin = `?company_id=${this?.dataCompany?._id}`;
      const response = await GetPeriodicActiveAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      console.log(response?.data);
      this.activePeriodic = response?.data?.periodic_month + " (" + response?.data?.periodic_start_date + " to " + response?.data?.periodic_end_date + ")";
    },
  },
  watch: {
    company: {
      handler() {
        this.getOutputFile();
        this.handleGetPeriodicActive();
      },
      deep: true,
    },
  },
};
</script>
